import React from 'react';
import { Placement } from '@noths/polaris-client-ribbons-design-system';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import {
  HOMEPAGE_WITHOUT_PLACEMENT,
  useHomepageRichRelevanceData,
} from 'src/hooks/useHomepageRichRelevanceData/useHomepageRichRelevanceData';
import { RecentlyViewed, RecentlyViewedProps } from './RecentlyViewed';

export interface RecentlyViewedWithRichRelevanceProps
  extends Omit<RecentlyViewedProps, 'placementType'> {
  currency: CurrencyCode;
  placementType: Placement | typeof HOMEPAGE_WITHOUT_PLACEMENT | null;
  sessionId?: string;
  hasDisabledCookies: boolean;
}

export const RecentlyViewedWithRichRelevance = ({
  currency,
  hasDisabledCookies,
  onNavigateCarousel,
  placementType,
  sessionId,
}: RecentlyViewedWithRichRelevanceProps) => {
  const data = useHomepageRichRelevanceData({
    placementType,
    sessionId,
    hasDisabledCookies,
  });

  return data ? (
    <RecentlyViewed
      currency={currency}
      items={data.items}
      onNavigateCarousel={onNavigateCarousel}
      placementTitle={data.message}
      placementType={Placement.HomepageRecentlyViewed}
      strategy={data.strategy}
    />
  ) : null;
};
